// src/utils/services/CodingOpportunities/updateCodingOpportunityStatus.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CodingOpportunities/status`;

/**
 * Actualiza el estado de un Coding Opportunity individual.
 *
 * @param {Object} params
 * @param {number} params.codingOpportunityId - ID del coding opportunity
 * @param {number} params.codStatus - ID del nuevo estado (0, 51-59)
 * @param {number} params.employeeUpdate - ID del empleado que realiza la actualización
 * @param {string} [params.updateDate] - Fecha de actualización (ISO string), default: now
 * @returns {Promise<Object>} - { message, rowsAffected }
 */
const updateCodingOpportunityStatus = async ({
  codingOpportunityId,
  codStatus,
  employeeUpdate,
  updateDate,
}) => {
  try {
    const response = await axios.put(
      API_URL,
      {
        codingOpportunityId,
        codStatus,
        employeeUpdate,
        updateDate: updateDate || new Date().toISOString(),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating coding opportunity status:", error);
    throw error;
  }
};

export default updateCodingOpportunityStatus;
